import { useState, useEffect } from 'react';

// Custom hook to manage services across components
export const useServices = () => {
  const [services, setServices] = useState([
    'Website Development',
    'Mobile App Development', 
    'Digital Marketing',
    'E-commerce Solution',
    'Software Development',
    'UI/UX Design',
    'SEO Services',
    'Social Media Marketing',
    'Business Consultation',
    'Technical Support'
  ]);

  // Load services from localStorage on mount
  useEffect(() => {
    const savedServices = localStorage.getItem('leadServices');
    if (savedServices) {
      try {
        const parsedServices = JSON.parse(savedServices);
        if (Array.isArray(parsedServices) && parsedServices.length > 0) {
          setServices(parsedServices);
        }
      } catch (error) {
        console.error('Error parsing saved services:', error);
      }
    }
  }, []);

  // Save to localStorage whenever services change
  useEffect(() => {
    localStorage.setItem('leadServices', JSON.stringify(services));
  }, [services]);

  return services;
};

export default useServices;
